import { useTranslations } from "use-intl";
import { friendlyErrorKind, readableErrorText } from "@/utils/friendlyError";

/** `friendlyError` / `friendlyWarnings` worded in the language the app shows. */
export function useFriendlyError() {
  const t = useTranslations("consultantDraft.errors");
  const friendlyError = (raw: string) => {
    const kind = friendlyErrorKind(raw);
    return kind ? t(kind) : readableErrorText(raw);
  };
  return { friendlyError, friendlyWarnings: (warnings: string[]) => warnings.map(friendlyError) };
}
